import Helper from '@ember/component/helper';
import _article from 'cio/utils/a';

/**
 *  Returns article of a word
 *
 * @param {string} word
 * @returns "a / an" (+? word)
 */

export function a([word, skipWord]: [string, boolean | undefined]) {
  if (word == null) {
    return '';
  }
  return _article(word, skipWord);
}

/*
  Basic Usage:

  // "an"
  ```handlebars
  {{a "example"}}
  ```

  // "an example"
  ```handlebars
  {{a "example" true}}
  ```
*/
export default Helper.helper(a);
